import SceneShell from "../components/SceneShell";
import PackageTable from "../components/PackageTable";

/**
 * Scene 11 — Packages page · stage-prop driven.
 *
 *   stage = 0  →  base table (Social Go vs Social Pro · no new products yet)
 *   stage = 1  →  PresenTour + NarraTour rows revealed with a pink pulse
 *
 * Each stage is registered as a separate slide in index.js for reliable
 * arrow navigation.
 */
export default function Scene11_PackageTable({ stage = 0 }) {
  return (
    <SceneShell variant="forest" align="center" data-testid="scene-package-table">
      <div className="relative max-w-[1280px] mx-auto w-full">
        <PackageTable revealed={stage >= 1} data-testid="package-table" />
      </div>
    </SceneShell>
  );
}
